var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioEmpty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 11.625C22.25 17.6311 17.3811 22.5 11.375 22.5C5.3689 22.5 0.5 17.6311 0.5 11.625C0.5 5.6189 5.3689 0.75 11.375 0.75C17.3811 0.75 22.25 5.6189 22.25 11.625ZM2.5137 11.625C2.5137 16.519 6.48104 20.4863 11.375 20.4863C16.269 20.4863 20.2363 16.519 20.2363 11.625C20.2363 6.73104 16.269 2.7637 11.375 2.7637C6.48104 2.7637 2.5137 6.73104 2.5137 11.625Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioEmpty);
export default __webpack_public_path__ + "static/media/radio-empty.f344997c6c451c05ecedd54074b452ca.svg";
export { ForwardRef as ReactComponent };